import { FormLabel } from "@common/components/ui/form"
import type { ReactNode } from "react"

export function FieldLabel({
  label,
  optional,
  className,
}: {
  label: ReactNode
  optional?: boolean
  className?: string
}) {
  return (
    <FormLabel className={className}>
      {label}
      {label && !optional && <span aria-hidden="true"> *</span>}
    </FormLabel>
  )
}
